<template>
  <div class="relative">
    <div
      class="hint-anchor flex flex-row items-center gap-1 semantic-tag tag-mute-01 text-sm ml-3 rtl:mr-3 rtl:ml-0 cursor-pointer font-[400]"
    >
      <div>{{ $t('TEAMS_SETTINGS.HINT.ANCHOR') }}</div>
      <span class="material-symbols-outlined text-base/[16px] text-[#475569]">
        help
      </span>
    </div>
    <div
      class="hint-content w-[310px] bg-white absolute top-[calc(100%+10px)] left-[10px] rtl:left-[unset] rtl:right-[10px] p-4 rounded-[12px] border border-gray-100 shadow-lg z-[100]"
    >
      <div class="text-lg font-bold text-gray-700 mb-2">
        {{ $t('TEAMS_SETTINGS.HINT.TITLE') }}
      </div>
      <p class="text-xs font-[400] text-gray-500 mb-2">
        {{ $t('TEAMS_SETTINGS.HINT.DESC_1') }}
      </p>
      <p class="text-xs font-[400] text-gray-500 m-0">
        {{ $t('TEAMS_SETTINGS.HINT.DESC_2') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.hint-anchor {
  ~ .hint-content {
    @apply hidden;
  }

  &:hover {
    ~ .hint-content {
      @apply block;
    }
  }
}
</style>
